import * as conf from "qpr-base/configuration";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../context/AppCtxProvider";
import LanguageSwitch from "./../viewcomponents/LanguageSwitch/LanguageSwitch";
import LanguageSwitchContainer from "./../viewcomponents/LanguageSwitchContainer/LanguageSwitchContainer";
import { makeThemedStyles } from "./../viewcomponents/utils";
type PropType = {
  left: string;
  right: string;
};

const useStyles = makeThemedStyles("LanguageSwitchView", (theme) => ({
  langText: {
    color: "rgba(255, 255, 255)",
    fontSize: "1.3em",
  },
}));
const LanguageSwitchView = () => {
  const { i18n, t } = useTranslation();
  const classes = useStyles();
  const ctx = useAppContext();

  if (conf.System.settings.languages.length < 2) return null;
  const lang_1 = conf.System.settings.languages[0];
  const lang_2 = conf.System.settings.languages[1];

  return (
    <div dir="ltr">
      <LanguageSwitchContainer>
        <div className={classes.langText}>{t(lang_1)}</div>
        <LanguageSwitch
          checked={i18n.language === lang_2}
          onChange={(event: any) => {
            const newLang = event.target.checked ? lang_2 : lang_1;
            i18n.changeLanguage(newLang);
            ctx.sendValue("language", newLang);
            ctx.sendValue("rtl", newLang === "ar");
            // Refresh the page to re-render all the components and completly apply the language change
            // In some components, the translated texts are passed as PROPS, so the parent component needs to be re-rendered.
            window.location.reload();
          }}
        />
        <div className={classes.langText}>{t(lang_2)}</div>
      </LanguageSwitchContainer>
    </div>
  );
};
export default LanguageSwitchView;
